<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout justify-center wrap>
            <v-flex xs12>
                <material-card>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-container fill-height fluid grid-list-xl>
                            <v-layout wrap style="background: #fff;" class="borderTop borderRight">
                                <v-flex md2 xs2 class="conTh py-2 borderBottom">게시상태</v-flex>
                                <v-flex md4 xs4 class="py-2 borderBottom ">
                                    <v-select
                                            v-model="model.posting_yn"
                                            :items="OPTIONS_OPEN_STATUS.slice(1,OPTIONS_OPEN_STATUS.length)"
                                            label="게시"
                                            flat
                                            hide-details
                                            solo
                                    ></v-select>
                                </v-flex>

                                <v-flex md2 xs2></v-flex>
                                <v-flex md4 xs4></v-flex>

                                <v-flex md2 xs2 class="conTh py-2 borderBottom">제목</v-flex>
                                <v-flex md10 xs10 class="py-2 borderBottom">
                                    <v-text-field
                                            v-model="model.title"
                                            label="제목을 입력해주세요"
                                            solo
                                            hide-details
                                            flat
                                    ></v-text-field>
                                </v-flex>

                                <v-flex md2 xs2 class="conTh py-2 borderBottom">내용</v-flex>
                                <v-flex md10 xs10 class="py-2 borderBottom">
                                    <div class="detailInfo">
                                        <editor api-key='40gjhoe9qw4arr3ts44g2km7b2h1fli0elf1ymr6dh2k1mhb'
                                                cloud-channel='dev' :init="editorConfig" v-model="model.content"></editor>
                                    </div>
                                </v-flex>

                                <v-flex xs12 text-xs-right class="borderNone">
                                    <v-btn class="mx-0 mr-1 font-weight-light" color="primary" outline @click="cancel()">취소</v-btn>
                                    <v-btn class="mx-0 font-weight-light" color="primary" @click="save()">저장</v-btn>
                                </v-flex>

                            </v-layout>
                        </v-container>
                    </v-form>
                </material-card>
            </v-flex>
        </v-layout>
    </v-container>

</template>

<script>
	import * as noticeApi from '../../service/api/notice-api'

	import MyMixinCommon from '../../mixins/MyMixinCommon';
    import {mapActions, mapGetters} from 'vuex'
	import Editor from '@tinymce/tinymce-vue';
    import {Notice} from "../../service/model/Notice";
    import moment from "moment";

	export default {
		mixins: [ MyMixinCommon ],
		components: {
			'editor': Editor
		},
		data: () => ({
			valid: true,
			model: new Notice(),
			items: [],
			dialog: false,
		}),
		created() {
            // 권한체크
            this.permissionCheck()
		},
		methods: {
			...mapActions( 'notices', [ 'demoAddContent' ] ),
            ...mapGetters( 'user', [ 'getUserId','getLoginType' ] ),
			/////////////////////////////////////////////////// FUNC /////////////////////////////////////////////////////////
            permissionCheck(){

                if(Number(this.getLoginType())  >= 3) {

                    // this.id = this.$route.params.id
                    this.valid = false
                    this.model.type = 'NOTICE'
                    this.model.posting_yn = true

                }else{

                    this.$dialog.alert('관리자 권한이 없어 메인페이지로 이동합니다.').then(dialog=>{
                        this.$router.push( 'contents' )
                    })
                }
            },

            cancel() {
				this.$router.back()
			},

			save() {

				if( ! this.$refs.form.validate() ) {
					this.$dialog.alert( '필수 정보를 입력해주세요.' )
					return;
				}

				if( ! this.model.posting_yn ) {
					this.$dialog.alert( '게시상태를 선택해주세요.' )
					return;
				}

				if( ! this.model.title ) {
					this.$dialog.alert( '제목을 입력해주세요.' )
					return;
				}

				if( ! this.model.content ) {
					this.$dialog.alert( '내용를 입력해주세요.' )
					return;
				}

				let data = {
                    title: this.model.title,
                    content: this.model.content,
                    posting_started_at: moment(new Date()).format("YYYY-MM-DD"),
                    posting_finished_at: '9999-12-31',
                    posting_yn: this.model.posting_yn,
				}

				this.$dialog.confirm( '저장 하시겠습니까?' )
				.then( dialog => {
                        this.reqCreate(data)

				} )
				.catch( function() {
				} )
			},

			/////////////////////////////////////////////////// REQ /////////////////////////////////////////////////////////

            reqCreate(data){
	            return noticeApi.createNotice( data ).then( res => {
		            this.$router.push( { name: 'notices' } );
	            }).catch(e=>{
		            this.$dialog.alert(e.message)
	            })
            }
		}
	}

</script>
